@if (opened) {
<ng-container [formGroup]="group()">
  @if (label()) {
  <label class=" label w-full">{{label()}}@if (required()) {
    <sup class="required">*</sup>
    }</label>
  }
  <div>
    <mat-form-field appearance="fill" class="dateSize w-full" class="{{class()}}">
      <input matInput [matDatepicker]="date" [formControlName]="name()" [placeholder]="placeholder()" [max]="maxDate()"
        [min]="minDate()" [readonly]="readonly()" [dateError]="dateError()" (keypress)="preventE($event)"
        (keydown)="deleteEvent($event)" autocomplete="off" (dateChange)="onValueChange($event)">
      <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
      <mat-datepicker #date color="primary"></mat-datepicker>
      @if (formField?.errors && formField?.errors?.required && !dateError()) {
      <mat-error [ngClass]="{'error-outline': formField && formField.invalid
    && (isFormSubmitted() || (!formField.pristine && isErrorOnChange()))  }">
        {{label()}} is Required
      </mat-error>
      }
      @if (formField?.errors && dateError()) {
      <mat-error [ngClass]="{'error-outline': formField && formField.invalid
  && (isFormSubmitted() || (!formField.pristine && isErrorOnChange()))  }">
        {{customError()}}
      </mat-error>
      }
    </mat-form-field>
  </div>
</ng-container>
}